export const toFixedRate = (rate?: number): string => {
  return rate ? rate.toFixed(1).replace('.', ',') : null;
};
